
























































import Vue from "vue"
import bus from "../lib/bus"
import vueLoading from 'vue-loading-template'

export default Vue.extend({
  data() {
    return {
      appName: APP_NAME,
      logoImg: URL_PREFIX + '/assets/logo.png',
      isLoading: false,
      notification: {
        show: false,
        classname: 'is-success',
        message: ''
      }
    }
  },

  created() {
    bus.$on('loading', () => {
      this.isLoading = true
    })
    bus.$on('loaded', () => {
      this.isLoading = false
    })
    bus.$on('notify', (message: string, classname: string = 'is-success') => {
      this.notification = { ...this.notification, ...{ show: true, classname: classname, message: message } }
    })
  },

  watch: {
    '$route': 'onCloseNotification'
  },

  components: {
    vueLoading
  },

  methods: {
    onCloseNotification() {
      this.notification = { ...this.notification, ...{ show: false } }
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue